import React from 'react';
import { Modal } from 'fronton-react/modal';
import { Portal } from 'fronton-react';
import { Breakpoint } from 'types/utils';
import { ModalLayoutDesktops } from './content-blocks/modal-layout-desktops';
import { ModalLayoutTouch } from './content-blocks/modal-layout-touch';
import { PictureSources } from './photos-modal.types';

export type PhotosModalProps = {
  breakpoint: Breakpoint;
  photos: PictureSources[];
  showedPicture: PictureSources | null;
  isShowed?: boolean;
  atSSR: boolean;
  setShowedPicture: (pic: PictureSources | null) => void;
  onCloseModal: () => void;
} & React.HTMLAttributes<HTMLElement>;

export const PhotosModal: React.FC<PhotosModalProps> = ({
  breakpoint,
  photos,
  showedPicture,
  isShowed = false,
  setShowedPicture,
  onCloseModal,
  atSSR,
  className = '',
  ...htmlProps
}) => {
  const atDesktop = breakpoint === 'large' || breakpoint === 'medium';
  const atTouch = breakpoint === 'tablet' || breakpoint === 'mobile';

  return (
    <>
      {!atSSR && (
        <Portal>
          <Modal
            className={className}
            modalID="reviews-photos-modal_mf-pdp"
            onClose={onCloseModal}
            show={isShowed}
            size="l"
            variant="full-screen"
            overlayClose
            closeButton={false}
            {...htmlProps}
          >
            {atDesktop && (
              <ModalLayoutDesktops
                breakpoint={breakpoint}
                photosThumbs={photos}
                showedPicture={showedPicture}
                onClose={onCloseModal}
                setShowedPicture={setShowedPicture}
              />
            )}

            {atTouch && (
              <ModalLayoutTouch
                breakpoint={breakpoint}
                photosThumbs={photos}
                showedPicture={showedPicture}
                onClose={onCloseModal}
                setShowedPicture={setShowedPicture}
              />
            )}
          </Modal>
        </Portal>
      )}
    </>
  );
};
